import { useCallback, useEffect } from 'react'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
import IconButton from '@aura/components/icon-button'
import Typography from '@aura/components/typography'
import Icon from '@aura/components/icon'
import { withStyles } from '@aura/components/styles'
import PropTypes from 'prop-types'
import { CancelOutlined, Close, ErrorOutline, ReportProblem } from '@mui/icons-material'
import Languages from '../../constants/languages'
import styles from './styles'


const bannerIcons = {
    'error': <CancelOutlined />,
    'info': <ErrorOutline />,
    'warning': <ReportProblem />
}

const Component = ({
    bannerInfo,
    closeBanner,
    classes
}) => {
    const { i18n } = useTranslation()
    const currentLocale = i18n.language

    const bannerIcon = bannerIcons[bannerInfo.severity] || bannerIcons.info

    useEffect(() => {
        const timer = setTimeout(() => {
            closeBanner()
        }, 10000)

        return () => clearTimeout(timer)
    }, [])

    const handleClose = useCallback(() => {
        closeBanner()
    }, [])

    if (!bannerInfo.display) return null

    return (
        <div className={classnames(classes[bannerInfo.severity || 'info'], classes.banner)}>
            <div className={classes.message}>
                <Icon>{bannerIcon}</Icon>
                <Typography variant="h3" overflow='hidden' sx={{ fontSize: '16px', textAlign: 'center' }}>{currentLocale === Languages.ENGLISH ? bannerInfo.message : bannerInfo.messageFr}</Typography>
            </div>
            <IconButton className={classes.icon} color='inherit' onClick={handleClose}>
                <Close />
            </IconButton>
        </div>
    )
}

Component.propTypes = {
    classes: PropTypes.object.isRequired,
    photourl: PropTypes.string
}

export default withStyles(Component, styles)
